<ng-container *ngIf="order$ | async as order">
  <div class="eb-order-detail-overview__header">
    <div class="eb-order-detail-overview__header-title">
      <h2 class="eb-items-title d-lg-block d-xl-block">
        {{ 'orderDetails.order' | cxTranslate }} {{ order?.salesDocNumber }}
      </h2>
      <button (click)="onClick('documents')" class="eb-order-detail-overview__document-link">
        {{ 'orderDetails.documents.documentTableLink' | cxTranslate }}
        <em class="fas fa-download"></em>
      </button>
    </div>
    <span class="eb-order-detail-overview__header-status">
      <span class="eb-order-detail-overview__header-status-label">
        {{ 'orderDetails.overallStatus' | cxTranslate }}
      </span>
      {{ order?.statusDisplay || ('statusText.' + order?.statusTextId | cxTranslate) }}
    </span>
  </div>

  <ng-container *ngIf="order.salesDocNumber; else loading">
    <eb-order-overview
      [selectedDeliveryMode]="currentDeliveryMode$ | async"
      [order$]="order$"
    ></eb-order-overview>
  </ng-container>
</ng-container>
<ng-template #loading>
  <eb-spinner class="my-3 d-block"></eb-spinner>
</ng-template>
